import React from 'react';
import PropTypes from 'prop-types';
import {Grid, Popup} from 'semantic-ui-react';

import SegmentHeader from '@appComponents/SegmentHeader';
import Chip from '@ui/Chip';
import ListingInfo from '@appComponents/ListingInfo';
import {CopyToClipboardRenderer} from '@appComponents/CopyToClipboardRenderer';

const StageDetails = ({stEvent, columnLength}) => {
    const stageFirsColumn = [
        {
            name: 'Stage ID',
            value: (
                <CopyToClipboardRenderer
                    text={stEvent.stage.id}
                    value={stEvent.stage.id}
                />
            ),
        },
        {
            name: 'Stage type',
            value: (
                <Popup
                    content={stEvent.stage.stage_type.description}
                    trigger={<span>{stEvent.stage.stage_type.name}</span>}
                    disabled={!stEvent.stage.stage_type.description}
                />
            ),
        },
    ];

    const stageThirdColumn = [
        {
            name: 'Disabled',
            value: stEvent.stage.is_disabled
                ? (<Chip size='small' color='error' label='Yes' />) : ('No'),
        },
    ];

    return (
        <div className='eventPageDetails'>
            <SegmentHeader>Stage details</SegmentHeader>
            <Grid columns={columnLength}>
                <Grid.Column>
                    <ListingInfo data={stageFirsColumn} />
                </Grid.Column>
                <Grid.Column>
                </Grid.Column>
                <Grid.Column>
                    <ListingInfo data={stageThirdColumn} />
                </Grid.Column>
            </Grid>
        </div>
    );
};

StageDetails.propTypes = {
    stEvent: PropTypes.shape({
        stage: PropTypes.shape({
            id: PropTypes.string.isRequired,
            stage_type: PropTypes.shape({
                name: PropTypes.string.isRequired,
                description: PropTypes.string,
            }),
            is_disabled: PropTypes.bool.isRequired,
        }),
    }),
    columnLength: PropTypes.number.isRequired,
};


export default StageDetails;
